
import {

  Navbar,
  Container,
} from "reactstrap";

const AdminNavbar = (props) => {
  return (
    <>
      <Navbar className="navbar-top " expand="md" id="navbar-main">
        <Container fluid>
          <p
            className="h4  text-uppercase d-none d-lg-inline-block"
        style={{marginTop:'-10px',marginLeft:'-16px'}}
          >
            {props.brandText}
          </p>
         
        </Container>
      </Navbar>
    
    </>
  );
};

export default AdminNavbar;
